import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CreatePlan from "../components/plans/CreatePlan";

const CreatePlanPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Create Plan' />

        <CreatePlan />

      </MasterLayout>
    </>
  );
};

export default CreatePlanPage;
